import {CgFigma} from 'react-icons/cg'
import { MdMessage } from 'react-icons/md'
import { BsYoutube } from 'react-icons/bs'
import { RiMessage2Line } from 'react-icons/ri'
import {FiWifi} from 'react-icons/fi'
import { VscSymbolProperty } from 'react-icons/vsc'
import { FaReact } from 'react-icons/fa'


const  cardType = [
    {
      icons:<FaReact style={{
        color:"#f9004d",
        height:"auto",
        width:"40px",
        fontSize:"16px",
        marginBottom:"29px"

    }}/>,

      title: "React JS",
      para: "Components are like functions that return HTML elements. I use Function components in Reactjs",
    },
    {
      icons:<MdMessage style={{
        color:"#f9004d",
        height:"auto",
        width:"40px",
        fontSize:"16px",
        marginBottom:"29px"

    }}/>,
      title: "Dynamic Data",
      para: "I use React Hooks to display data. Instead of Hard Coded data. therefore i use Hooks.",
    },
    {
      icons:<CgFigma style={{
        color:"#f9004d",
        height:"auto",
        width:"40px",
        fontSize:"16px",
        marginBottom:"29px"

    }}/>,
      title: "Design Figma",
      para: "I build different figma design such as i upload on my personal portfolio.",
    },
    {
      icons:<FiWifi style={{
        color:"#f9004d",
        height:"auto",
        width:"40px",
        fontSize:"16px",
        marginBottom:"29px"

    }}/>,
      title: "Secure Routes",
      para: "With the help of React-Router-Dom, and React Hooks. I create Runtime Routes. Accessible only for Authorised Users",
    },
    {
      icons:<BsYoutube style={{
        color:"#f9004d",
        height:"auto",
        width:"40px",
        fontSize:"16px",
        marginBottom:"29px"

    }}/>,
      title: "News Lovers",
      para: "News Lovers is my You Tube channel name. I'm also write a content for my videos and record the voice and also edit the video.",
      link:"https://www.youtube.com/channel/UCbrPRhtO1HO2k9WsZsCIpfA",
    },
    {
      icons:<VscSymbolProperty style={{
        color:"#f9004d",
        height:"auto",
        width:"40px",
        fontSize:"16px",
        marginBottom:"29px"

    }}/>,
      title: "Personal Portfolio April",
      para: "It uses adictionary of over 200 Latin words,combined withahandful of model sentence.",
    },
  ];
  
  export default cardType
